import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GivebackRoutingModule } from './giveback-routing.module';
import { GivebackComponent } from './giveback.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HgCommonModule } from '../hg-common/hg-common.module';

@NgModule({
  imports: [
    CommonModule,
    GivebackRoutingModule,
    HgCommonModule
  ],
  declarations: [GivebackComponent, HeaderComponent, FooterComponent]
})
export class GivebackModule { }
